import React, { useState } from 'react';
import './sidebar.css';
import Logo from '../../assets/J.png';

const Sidebar = () => {
    const [toggle, showMenu] = useState(false);
    return (
        <>
            <aside className={toggle ? "aside show-menu" : "aside"}>
                <a href="#home" className="nav__logo">
                    <img src={Logo} alt="" />
                </a>

                <nav className="nav">
                    <div className="nav__menu">
                        <ul className="nav__list">
                            <li className="nav__item">
                                <a href="#home" className="nav__link"> <i className="fa-solid fa-paw"></i></a>
                            </li>
                            <li className="nav__item">
                                <a href="#about" className="nav__link"><i className="fa-solid fa-dog"></i></a>
                            </li>
                            <li className="nav__item">
                                <a href="#services" className="nav__link"><i className="fa-solid fa-bone"></i></a>
                            </li>
                            <li className="nav__item">
                                <a href="#pricing" className="nav__link"><i className="fa-solid fa-shield-dog"></i></a>
                            </li>
                            <li className="nav__item">
                                <a href="https://www.instagram.com/?hl=en" className="nav__link"><i className="fa-regular fa-image"></i></a>
                            </li>
                            <li className="nav__item">
                                <a href="#testimonials" className="nav__link"><i className="fa-solid fa-face-smile"></i></a>
                            </li>
                            <li className="nav__item">
                                <a href="#contact" className="nav__link"><i className="fa-solid fa-comment-dots"></i></a>
                            </li>
                        </ul>
                    </div>
                </nav>

                <div className="nav__footer">
                    <span className="copyright">&copy; 2022 - 2023.</span>
                </div>
            </aside >

            <div className={toggle ? "nav__toggle nav__toggle-open" : "nav__toggle"} onClick={() => showMenu(!toggle)}>
                <i className="icon-menu"></i>
            </div>
        </>
    );
};

export default Sidebar;